<style scoped>
.this__card {
  border: 1px solid var(--homeBannerBorder);
  border-radius: 30px;
  overflow: hidden;
  line-height: normal;
  opacity: 0;
  width: 1230px;
  max-width: 100svw;
}
.this__card--inner {
  height: 328px;
  padding-left: 60px;
}

.this__title {
  max-width: 510px;
}

.this__image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-image: var(--homeBannerBackground);
  background-repeat: no-repeat;
  background-position-x: calc(100% - 1px);
  background-size: cover !important;

  animation: pulseBg 5s infinite ease-in-out;
}

@keyframes pulseBg {
  0% {
    background-size: 100%;
    opacity: 1;
  }
  50% {
    background-size: 101%;
    opacity: 0.7;
  }
  100% {
    background-size: 100%;
    opacity: 1;
  }
}

@media (max-width: 992px) {
  button {
    width: 100% !important;
  }
  .this__title {
    max-width: unset;
  }
  .this__text {
    text-align: center;
    /* max-width: unset; */
  }
  .this__card {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
  .this__card--inner {
    padding: 20px !important;
    height: 364px !important;
  }
  .this__image::before {
    background-image: url(@/assets/images/home-bg-mobile.svg);
    background-size: cover;
  }
  .demo__BubbleBlock--col {
    margin: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-top: 0 !important;
  }
}
</style>
<template>
  <div
    class="this__card demo__bg--gradient-border demo__BubbleBlock--col"
    v-bind:class="{
      'animated fadeIn':
        user?.plan || user === undefined || user?.plan === null,
    }"
  >
    <div class="demo__bg--bgBannerPrimary">
      <div class="this__image demo__relative">
        <a-row
          class="this__card--inner"
          type="flex"
          justify="space-around"
          align="middle"
        >
          <a-col :lg="0" :xs="24">
            <img :src="$root.logoImg" class="tm_logo demo__margin-bottom--20" />
          </a-col>
          <a-col :lg="12" :xs="24" class="this__text">
            <h1
              class="demo__font--30 demo__weight--600 demo__font-mobile--22 demo__weight-mobile--800 demo__color--white this__title"
              v-html="bannerText.title"
            ></h1>
            <div
              class="demo__font--18 demo__weight--400 demo__font-mobile--16 demo__weight-mobile--400 demo__margin-top--16 demo__color--white this__desc"
              v-html="bannerText.desc"
            ></div>

            <div
              class="demo__flex demo__margin-top--40 demo__margin-top-mobile--24 this__text"
              v-bind:class="{
                'demo__flex-column': isMobile,
                'demo__flex-middle': !isMobile,
              }"
            >
              <AuthLockBlock
                v-if="bannerText.button === 'notAuth'"
                ym_location="main-title"
                modal-status="Reg"
                class="demo__block--mobile"
                v-bind:class="{
                  'demo__margin-right--29': !isMobile,
                }"
              >
                <a-button class="demo__button demo__button--base">
                  {{ $t("Register") }}
                  <i
                    class="fa-light fa-chevron-right demo__margin-left--12"
                  ></i>
                </a-button>
              </AuthLockBlock>

              <a-button
                v-else-if="bannerText.button === 'baseSub'"
                class="demo__button demo__button--base"
                @click="$store.dispatch('updateSubsModalStatus', true)"
              >
                {{ $t("homepage.connect") + cost }}
                <i class="fa-light fa-chevron-right demo__margin-left--12"></i>
              </a-button>

              <a-button
                v-else-if="bannerText.button === 'toAI'"
                class="demo__button demo__button--base"
                @click="$router.push('/AI/services')"
              >
                {{ $t("homepage.goToAI") }}
                <i class="fa-light fa-chevron-right demo__margin-left--12"></i>
              </a-button>
              <a-button
                v-if="!agent && isAndroid && downloadAppCondition"
                class="demo__button demo__button--gray demo__button--not-animate demo__block--mobile"
                v-bind:class="{
                  'demo__margin-top--15': isMobile,
                }"
              >
                <a
                  href="https://play.google.com/store/apps/details?id=co.thirdopinion.app"
                  target="_blank"
                >
                  {{ $t("Download app") }}
                  <i
                    class="fa-light fa-arrow-down-to-line demo__margin-left--12"
                  ></i>
                </a>
              </a-button>
            </div>
          </a-col>
          <a-col :lg="12" :xs="0"> </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["user", "userIsBaseSub", "isMobile", "agent", "subsPlans"]),
    downloadAppCondition() {
      return process.env.VUE_APP_INSTALLATION === "ru";
    },
    isAndroid() {
      return /android/i.test(navigator.userAgent);
    },
    cost() {
      const cost = this.$_.findWhere(this.subsPlans, {
        is_featured: true,
      })?.cost;
      return (cost || "--") + this.$t("homepage.cost");
    },
    bannerText() {
      let text;

      if (!this.user || (!this.user?.plan && this.user?.plan !== null)) {
        text = {
          title: this.$t(
            "homepage.notAuthSub__" + process.env.VUE_APP_ENABLE_SUBS + ".title"
          ),
          desc: this.$t(
            "homepage.notAuthSub__" + process.env.VUE_APP_ENABLE_SUBS + ".desc"
          ).replace("<PRICE>", this.cost),
          button: "notAuth",
        };
      } else if ((!this.user || this.userIsBaseSub) && this.$root.showLogic) {
        text = {
          title: this.$t("homepage.baseSub.title"),
          desc: this.$t("homepage.baseSub.desc"),
          button: "baseSub",
        };
      } else {
        text = {
          title: this.$t("homepage.notBaseSub.title"),
          desc: this.$t("homepage.notBaseSub.desc"),
          button: "toAI",
        };
      }

      return text;
    },
  },
  created() {
    this.$accessModule("home_banner", this);
  },
};
</script>
